// TODO: Remove from `core-js@4`
require('../modules/es.string.match-all');



// WEBPACK FOOTER //
// webpack://pdfmake/node_modules/core-js/modules/esnext.string.match-all.js